/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type KeyPressAction = {
  type: "keypress";
  keys: Array<string>;
};

/** @internal */
export const KeyPressAction$inboundSchema: z.ZodType<
  KeyPressAction,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("keypress"),
  keys: z.array(z.string()),
});
/** @internal */
export type KeyPressAction$Outbound = {
  type: "keypress";
  keys: Array<string>;
};

/** @internal */
export const KeyPressAction$outboundSchema: z.ZodType<
  KeyPressAction$Outbound,
  z.ZodTypeDef,
  KeyPressAction
> = z.object({
  type: z.literal("keypress"),
  keys: z.array(z.string()),
});

export function keyPressActionToJSON(keyPressAction: KeyPressAction): string {
  return JSON.stringify(KeyPressAction$outboundSchema.parse(keyPressAction));
}
export function keyPressActionFromJSON(
  jsonString: string,
): SafeParseResult<KeyPressAction, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => KeyPressAction$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'KeyPressAction' from JSON`,
  );
}
